// import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
import { faShippingFast } from "@jewlr/sharp-light-svg-icons/faShippingFast"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { jewlr_t, IS_JEWLR } from "helpers/application"
import { showHolidayShippingInfoPDP } from "helpers/holiday"

const Title = () => {
  const holidayDelivery = useSelector(
    (state) => state.wizard.shipping.main?.available_holiday_delivery
  )
  const isAccessory = useSelector(
    (state) => state.wizard.description.product_type === "ACCESSORY"
  )

  const holidayStyle = showHolidayShippingInfoPDP() && holidayDelivery

  if (holidayStyle) {
    // const arriveBy =
    //   new Date(minDeliveryDate).getDate() ==
    //   new Date(sl.config.guaranteed_receive_date).getDate()
    const text = `${
      sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    } ${jewlr_t("terms.Shipping")}`
    // ship.view_type === "AVAILABLE_HOLIDAY"
    //   ? // ? ` Arrives ${arriveBy ? "By" : "Before"} ${
    //     `Arrives Before ${
    //       sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    //     }`
    //   : `${
    //       sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday
    //     } Shipping Info`
    // `${sl.config.guaranteed_holiday} ${jewlr_t("terms.Shipping")} Info`
    // const text = `${sl.config.guaranteed_holiday} Shipping Info`
    return (
      <div className="text-black-print mb-12 flex items-center justify-center">
        <FontAwesomeIcon
          className="text-16 tablet:text-18 mr-8 align-text-top"
          icon={faShippingFast}
        />
        <h2 className="text-16 tablet:tracking-tight leading-20 font-semibold">
          {text}
        </h2>
      </div>
    )
  }
  return (
    <div className="mb-8 flex items-center justify-center">
      {IS_JEWLR() ? (
        <>
          <FontAwesomeIcon
            className="text-18 mr-4 align-text-top"
            icon={faGift}
          />
          <h2 className="text-16 tablet:text-18 font-semibold">
            {isAccessory
              ? `${jewlr_t("terms.Shipping")} Information`
              : "Custom made for you!"}
          </h2>
        </>
      ) : (
        <>
          <FontAwesomeIcon
            className="text-22 mr-4 align-text-top"
            icon={faShippingFast}
          />
          <h2 className="text-16 tablet:text-18 font-semibold">
            {jewlr_t("terms.Shipping")} Info
          </h2>
        </>
      )}
    </div>
  )
}

export default Title
